import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateBlockGrid(section, textLines, blocks) {

  // Individual tweens 
  // Animated lines of text
  let textLinesTween = textLines ? gsap.to(textLines, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  let blocksTween = blocks ? gsap.to(blocks, {
    duration: 0.8,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "power1.in",
      from: "start",
    },
  }) : null;

  // Timeline
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
    },
  });

  tl
    .add(textLinesTween)
    .add(blocksTween);

}